export const PraiceSpace = (str: string): string => {
  if (str) {
    const reversedStr = str.toString().split("").reverse().join("");
    const spacedStr = reversedStr.replace(/(\d{3})/g, "$1 ").trim();
    const formattedStr = spacedStr.split("").reverse().join("");

    const hasDecimalZeros = str.endsWith(".00");

    const finalStr = hasDecimalZeros
      ? formattedStr.replace(".00", "")
      : formattedStr;

    return `${finalStr} ₽`;
  }
  return "";
};
